exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header{position:fixed;top:0;left:0;width:100vw;z-index:80;overflow:hidden;transform:translateY(-100%)}.header-wrapper{padding:40px 5vw;display:flex;justify-content:flex-end;position:relative}.header-wrapper .su-logo{position:absolute;top:0;left:0;width:80px}.header-wrapper .su-logo img{width:100%}.header-wrapper .burger-button{position:absolute;top:42px;left:calc(50% - 10px)}.header-wrapper .nav{display:flex;align-items:center}.header-wrapper .nav a,.header-wrapper .nav p{color:#fff;font-size:14px;letter-spacing:.15em;font-family:Saira Extra Condensed,sans-serif;font-weight:300;text-transform:uppercase}.header-wrapper .nav .credits-link{margin:0 20px;border:1px solid #fff;padding:.2em .4em;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4204f070","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/partials/header.vue
// module id = 370
// module chunks = 0